export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/iphone_ipad_app.b970ca2.svg";